import { DownOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { Flex, Image, Menu, MenuProps, Space, Switch, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext/Index";
import AuthService from "../../Services/auth.service";
import JobDescriptionService from "../../Services/job-description.service";
import "./index.scss";
import { useTheme } from "../../Context/ThemeContext";
import useOrganization from "../../Hooks/useOrganization";
import { JobDescription } from "../../Entities/job-description.entity";
import { openNotification } from "../Notification/Index";

const Navigator = () => {
  const [current, setCurrent] = useState("");
  const { isUserLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { organization } = useOrganization();
  const { isDarkMode, toggleTheme } = useTheme();

  const [jobPosts, setJobPosts] = useState<JobDescription[]>([]);

  useEffect(() => {
    fetchJobPosts();
  }, []);

  const fetchJobPosts = async () => {
    try {
      const data =
        await JobDescriptionService.getInstance().findAllJobPostWithFiletrsAndPositionCounts(
          {
            page: 1,
            limit: 10,
            position: [],
            searchQuery: null,
          }
        );

      if (!data || !data.jobPosts) {
        console.error("Invalid response format from job posts API");
        setJobPosts([]);
        return;
      }

      setJobPosts(data.jobPosts);
    } catch (error) {
      console.error("Error fetching job positions:", error);
      setJobPosts([]);
    }
  };

  const onSignOut = async () => {
    await AuthService.getInstance().signOut();
  };

  const user = AuthService.getInstance().getCurrentUser();

  const onClickLogo = () => {
    navigate("/");
  };

  const onClick: MenuProps["onClick"] = (e) => {
    switch (e.key) {
      case "home":
        window.location.replace(
          organization?.orgWebsite
            ? organization.orgWebsite
            : "https://qualifyme.ai"
        );
        break;
      case "sign_out":
        onSignOut();
        break;
      case "profile":
        navigate("/profile");
        break;
      case "listing":
        navigate("/");
        break;
      case "sign_in":
        navigate("/sign-in");
        break;
      default:
        navigate("/sign-in");
        break;
    }
  };

  useEffect(() => {
    const path = location.pathname;
    setCurrent(path.replace(/^\/|\/$/g, ""));
  }, [location]);

  const handleSupportClick = () => {
    const email = "support@qualifyme.ai";
    const subject = "Support Request";
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}`;

    let mailClientLikelyOpened = false;

    const handleBlur = () => {
      mailClientLikelyOpened = true;
      window.removeEventListener("blur", handleBlur);
    };

    window.addEventListener("blur", handleBlur);

    window.location.href = mailtoLink;

    setTimeout(() => {
      window.removeEventListener("blur", handleBlur);

      if (!mailClientLikelyOpened) {
        const fallbackGmailLink = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(
          subject
        )}`;
        const newTab = window.open(fallbackGmailLink, "_blank");

        if (newTab) {
          newTab.focus();
        } else {
          openNotification(
            "warning",
            "Blocker detected",
            `Please allow pop-ups for this site or visit email app  and send email to ${email}.`
          );
        }
      }
    }, 750);
  };

  return (
    <Flex
      justify="space-between"
      align="center"
      style={{ maxWidth: 1440, margin: "0 auto" }}
    >
      <Flex align="center">
        {organization?.logo ? (
          <Image
            preview={false}
            src="error"
            fallback={`https://hiring-assistant-files.s3.ap-south-1.amazonaws.com/organization/${organization?._id}/${organization?.logo}`}
            onClick={onClickLogo}
            style={{ margin: "0px 16px", cursor: "pointer" }}
            width="48px"
            height="auto"
          />
        ) : (
          <Image
            src="/assets/qualifyme_light.png"
            alt="ai_icon"
            className="svg-icon"
            preview={false}
            onClick={onClickLogo}
            style={{ margin: "0px 16px", cursor: "pointer" }}
            width="48px"
            height="auto"
          />
        )}
        {jobPosts.length > 0 && (
          <Menu
            onClick={onClick}
            theme="dark"
            selectedKeys={[current]}
            style={{ marginLeft: "16px", flex: 1, minWidth: 0 }}
            multiple={false}
            className={`header_menu ${isDarkMode ? "" : "ant-menu-dark"}`} // Conditionally add dark mode class
            items={[
              {
                label: <span className="header_link">All Openings</span>,
                key: "listing",
                className: `${isDarkMode ? "ant-menu-dark" : "light-mode"}`,
              },
            ]}
          />
        )}
      </Flex>
      <Space>
        {/* <Switch
          checkedChildren={"Dark"}
          unCheckedChildren={"Light"}
          checked={isDarkMode}
          onClick={toggleTheme}
        /> */}
        <Tooltip placement="bottom" title="support@qualifyme.ai">
          <span className="support_link" onClick={handleSupportClick}>
            Support
          </span>
        </Tooltip>
        <Menu
          theme="dark"
          onClick={onClick}
          selectedKeys={[current]}
          multiple={false}
          expandIcon={<DownOutlined />}
          className={`header_menu ${isDarkMode ? "" : "ant-menu-dark"}`}
          items={
            isUserLoggedIn
              ? [
                  {
                    label: (
                      <span className="header_link">{user?.firstName}</span>
                    ),
                    icon: <UserSwitchOutlined />,
                    key: "profile",
                    children: [
                      {
                        label: "Profile",
                        key: "profile",
                      },
                      {
                        label: "Sign out",
                        key: "sign_out",
                      },
                    ],
                  },
                ]
              : jobPosts.length > 0
              ? [
                  {
                    label: <span className="header_link">Sign in</span>,
                    key: "sign_in",
                  },
                ]
              : []
          }
        />
      </Space>
    </Flex>
  );
};

export default Navigator;
